import axios from '@/plugins/axios'

function store(data) {
  return axios.post('/document-templates', data)
    .then(response => response.data)
}

function update(data, id) {
  return axios.patch(`/document-templates/${id}`, data)
    .then(response => response.data)
}

export default {
  fetch(params) {
    return axios.get('/document-templates', { params: params })
      .then(response => response.data)
  },
  fetchHelp() {
    return axios.get('/document-templates/help')
      .then(response => response.data)
  },
  destroy(id) {
    return axios.delete(`/document-templates/${id}`)
  },
  save(data, id) {
    return id ? update(data, id) : store(data)
  },
  updateOrder(data) {
    return axios.post('/document-templates/order', data)
      .then(response => response.data)
  }
}
